import React from "react";
import PropTypes from "prop-types";
import { FaCheckCircle, FaTimesCircle, FaExclamationTriangle, FaExternalLinkAlt } from "react-icons/fa";
import styles from "../subscriptions.module.css";

const formatAmount = amount =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(amount);

const formatDate = timestamp =>
  new Date(timestamp * 1000).toLocaleDateString("pt-BR");

const CurrentPlanActions = ({ subscriptionDetail, onManage }) => {
  if (!subscriptionDetail) return null;

  const isCanceled = subscriptionDetail.is_canceled;
  const isActive   = subscriptionDetail.status_raw === "active";
  const isTrialOnly = Boolean(subscriptionDetail.in_trial) && !isActive;

  let statusClass = styles.inactive;
  let statusLabel = subscriptionDetail.status || "Inativo";
  if (isCanceled) { statusClass = styles.canceled; }
  else if (isActive) { statusClass = styles.active; }

  return (
    <div className={styles.planCard}>
      <div className={styles.planCardLeft}>
        <div>
          <div className={styles.planNameLabel}>Plano atual</div>
          <div className={styles.planBadgeRow}>
            <span className={styles.planName}>{subscriptionDetail.plan || "Nenhum"}</span>
            <span className={`${styles.statusPill} ${statusClass}`}>
              <span className={styles.statusDot} />
              {statusLabel}
            </span>
          </div>
        </div>

        {(subscriptionDetail.amount > 0 || subscriptionDetail.current_period_end) && (
          <div className={styles.planMeta}>
            {subscriptionDetail.amount > 0 && (
              <div className={styles.planMetaItem}>
                <span className={styles.planMetaLabel}>Valor mensal</span>
                <span className={styles.planMetaValue}>{formatAmount(subscriptionDetail.amount)}</span>
              </div>
            )}
            {subscriptionDetail.current_period_end && !isTrialOnly && (
              <div className={styles.planMetaItem}>
                <span className={styles.planMetaLabel}>
                  {isCanceled ? "Acesso até" : "Próxima cobrança"}
                </span>
                <span className={styles.planMetaValue}>
                  {formatDate(subscriptionDetail.current_period_end)}
                </span>
              </div>
            )}
          </div>
        )}
      </div>

      {!isTrialOnly && (
        <div className={styles.planCardRight}>
          <button className={styles.btnManage} onClick={onManage}>
            <FaExternalLinkAlt size={11} />
            Gerenciar Assinatura
          </button>
        </div>
      )}
    </div>
  );
};

CurrentPlanActions.propTypes = {
  subscriptionDetail: PropTypes.object,
  onManage: PropTypes.func.isRequired
};

export default CurrentPlanActions;
